<template>
  <div class="rounded">
    <div class="lg:shadow-lg bg-white rounded-zt-sm w-full mb-3 px-4 py-3">
      <h1 class="text-zt-primary-200 text-zt-xl mb-2">
        {{ greetingTime }} {{ getNamesUser }},
      </h1>
      <p>
        {{ $t("message.inicioComponent.welcomeAgainMsg") }}
      </p>
    </div>
    <template v-if="isUserActive">
      <div v-if="loadingBoarding"
        class="empty-board-wrapper lg:shadow-lg bg-white rounded-zt-sm flex flex-col md:flex-wrap items-center justify-center w-full">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </div>

      <div class="overflow-hidden" v-if="loadingBoarding === false">
        <div v-if="board.activeBoards.length > 0">
          <div v-for="(item, index) in board.activeBoards" :key="index">
            <v-card class="dashBoardCard mb-4" :key="item[index]">
              <v-card-text>
                <div class="dashBoardTitle text-zt-xl font-normal buttonPrimary--text">
                  {{ item.asunto }}
                </div>
                <div class="dashBoardContent grayFont--text text-zt-base" v-html="item.mensaje"></div>
                <div class="d-flex xl:min-h-full lg:min-h-full dashBoardVideo justify-center ml-auto mr-auto mt-3 w-3/4"
                  v-if="item.url">
                  <iframe :src="getFormatedUrl(item.url)" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                  </iframe>
                </div>
                <div v-if="item.archivo">
                  <div v-if="item.archivo.tipo === 'application/pdf'"
                    :class="isMobile() ? 'dashBoardContainerDocument' : ''">
                    <div v-if="item.archivo.imageBase64">
                      <PDFVisualizer :file="item.archivo.imageBase64" />
                    </div>
                  </div>
                  <div v-else class="imageCotainerDashboard ml-auto mr-auto w-3/4 my-3"
                    :class="{ 'imageContentDashboard--mobile': isMobile() }">
                    <img class="imageContentDashboard" alt="imagen" :src="item.archivo.imageDecode" />
                  </div>
                  <div v-if="item.archivo.totalPages > 1" class="navigateContainer">
                    <button data-vs-button="goto-page" :disabled="item.archivo.page == 1"
                      @click="goToPageButton('-1', item.archivo.page, index)" class="navigateArrowsContainerRight">
                      <span class="icon-leftChevronNavigateDocs"> </span>
                      <span :disabled="item.archivo.page == 1" class="textNavigateArrows">{{
                        $t('message.homeComponent.homeContents.prev_page')
                      }}</span>
                    </button>
                    <div class="pagesDashboardCount px-1" style="min-width:30px">
                      {{ item.archivo.page }} / {{ item.archivo.totalPages }}
                    </div>
                    <button data-vs-button="goto-page" :disabled="item.archivo.page === item.archivo.totalPages"
                      class="navigateArrowsContainerLeft" @click="goToPageButton('1', item.archivo.page, index)">
                      <span :disabled="item.archivo.page === item.archivo.totalPages
                        " class="textNavigateArrows">{{
                          $t('message.homeComponent.homeContents.next_page')
                        }}</span>
                      <span class="icon-rightChevronNavigateDocs"> </span>
                    </button>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
        <div v-else>
          <div
            class="empty-board-wrapper lg:shadow-lg bg-white rounded-zt-sm flex flex-col md:flex-wrap items-center justify-center w-full">
            <div class="w-full md:w-2/5 h-48 text-center md:text-right">
              <graphic-base height="100%" width="75%" viewBox="0 0 172 108">
                <empty-boardsvg />
              </graphic-base>
            </div>
            <div class="md:w-3/5 md:p-20 md:pl-24 mt-8">
              <p class="text-zt-primary-200 text-zt-lg text-center md:text-left">
                {{ $tc('message.inicioComponent.dashboard.noDashboardTitle') }}
              </p>
              <p class="text-zt-dark-400 text-zt-sm text-center md:text-left">
                {{
                  $tc('message.inicioComponent.dashboard.noDashboardSubtitle')
                }}
              </p>
              <p v-if="isRRHH" class="text-zt-dark-400 text-zt-sm text-center md:text-left">
                <a :href="mainUrl" target="blank" class="text-zt-dark-400">
                  {{
                    $tc('message.inicioComponent.dashboard.uploadNewNovelty')
                  }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Users from '../../../apiClient/Users'
import PinchZoom from 'pinch-zoom-js'
import graphicBase from '../../../components/commons/Illustrations/graphicBase'
import emptyBoardsvg from '../../../components/commons/Illustrations/graphicSVG/graphicEmptyBoard'
import { mapGetters, mapActions } from 'vuex'
import PDFVisualizer from '@/components/generics/PDFVisualizer.vue'
import moment from 'moment'
import { map, assign, orderBy } from 'lodash'

export default {
  components: {
    graphicBase,
    emptyBoardsvg,
    PDFVisualizer
  },
  data() {
    return {
      board: {
        activeBoards: [],
        handleZoom: false
      },
      isRRHH: false,
      loadingBoarding: false,
      boardAccess: false,
      mainUrl: 'https://pas.sichern.com.ar'
    }
  },
  computed: {
    ...mapGetters(['getUser', 'isUserActive']),
    ...mapGetters('home', ['getOrderedBoards']),
    greetingTime() {
      let date = new Date()
      let hours = date.getHours()
      let greeting = ''
      if (hours < 12) greeting = this.$t('message.greeting.morning')
      if (hours > 12 && hours < 18)
        greeting = this.$t('message.greeting.afternoon')
      if (hours > 18) greeting = this.$t('message.greeting.evening')
      return greeting
    },
    getNamesUser() {
      return `${this.getUser.nickname}`
    }
  },
  async created() {
    window.scrollTo(0, 0)
    this.user = new Users()
    this.boardAccess = this.$store.getters.getUser.estado_empresa != 3
    this.getBoards()
    this.getProfileRRHH()
  },

  async mounted() {
    this.$watch(
      'board.activeBoards',
      () => {
        if (this.board.activeBoards.length > 0) {
          this.loadingBoarding = false
        }
      },
      { immediate: true }
    )
  },

  methods: {
    ...mapActions('home', ['setInitialBoards']),
    async getBoards() {
      try {
        this.loadingBoarding = true
        const activeBoardsResponse = await this.user.getActiveBoards()
        if (activeBoardsResponse.data.results.data.length > 0) {
          const activeBoards = activeBoardsResponse.data.results.data
          const boardPromises = map(activeBoards, async board => {
            if (board.archivo) {
              const response = await this.user.getDocumentBoard(board.id)
              const data_uri_prefix = 'data:image/*;base64,'
              const image = {
                imageDecode: data_uri_prefix + response,
                imageBase64: response,
                page: 1,
                totalPages: undefined,
                adviseToZoom: true
              }
              board.archivo = assign(board.archivo, image)
              return board
            }
            return board
          })

          const responses = await Promise.all(boardPromises)
          return (this.board.activeBoards = orderBy(
            responses,
            [
              object => {
                return moment(object.fecha_desde, 'DD/MM/YYYY')
              }
            ],
            ['desc']
          ))
        }
        this.loadingBoarding = false
      } catch (error) {
        this.loadingBoarding = false
        const is401 = error.response && error.response.status === 401;
        const text = is401 ? this.$t('message.Errors.401.sub_title_401') : this.$t(
            `message.errorReference.${error.response.data.response_v2.code}`
          );
        const typeSwal = is401 ? 'info' : 'error';
        this.$swal({
          type: typeSwal,
          title: text,
          showConfirmButton: true,
          confirmButtonText: this.$t("message.Pickup.accept")
        })
      }
    },
    getFormatedUrl(url) {
      const youtube = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
      const vimeo = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i
      if (url) {
        if (url.match(youtube)) {
          return `https://www.youtube.com/embed/${url.match(youtube)[1]}`
        } else if (url.match(vimeo)) {
          return `https://player.vimeo.com/video/${url.match(vimeo)[1]
            }?color=5cd7d4&byline=0&portrait=0`
        } else {
          console.log(this.$t("message.workflow.urlNoValid"))
        }
      }
    },
    activateZoomOnDoc(index, item) {
      if (this.isMobile()) {
        let el = document.querySelector('.dashBoardDocument' + index)
        item.archivo.adviseToZoom = false
        if (el !== null) {
          const myScroll = new PinchZoom(el)
          this.board.handleZoom = true
        }
      }
    },
    goToPageButton(direction, objectPage, index) {
      if (direction == '-1') {
        this.board.activeBoards[index].archivo.page--
      } else if (direction == '1') {
        this.board.activeBoards[index].archivo.page++
      }
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    },
    getProfileRRHH() {
      this.getUser.perfiles.forEach(profile => {
        if (
          profile.nombre.includes('RRHH') &&
          !profile.nombre.includes('X_SECTOR')
        ) {
          this.isRRHH = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './home.scss';

.welcomeNameHeader {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 0.5em;
  color: $bluePrimary;
}

.welcomeText {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: $textPrimary;
}

.greenTextWelcomeText {
  color: $buttonPrimary;
}

.backgroundHolidaysDocuments {
  background-color: $background !important;
}

.documentsToSignBox {
  background-size: 100%;
  height: 182px;
}

.licensesBox {
  background-size: 100%;
  height: 182px;
}

.halfDocumentBox {
  width: 50%;
  display: inline-block;
  background-size: cover;
  height: 182px;
}

.halfSignBox {
  width: 50%;
  display: inline-block;
  background-size: cover;
  height: 182px;
}

.documentsToSignHalfBoxTitle {
  text-align: center;
  width: 80%;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  position: relative;
  float: left;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: $white;
}

@media (max-width: 330px) {
  .documentsToSignHalfBoxTitle {
    text-align: center;
    width: 80%;
    font-family: Roboto, Arial, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    position: relative;
    float: left;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $white;
  }
}

.documentsToSignHalfBoxSubtitle {
  text-align: center;
  width: 80%;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  position: relative;
  float: left;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: $white;
}

.documentsToSignBoxTitle {
  text-align: center;
  display: block;
  width: 90%;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  position: relative;
  float: left;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: $white;
}

.documentsToSignBoxSubtitle {
  display: block;
  width: 90%;
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  position: relative;
  float: left;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.test {
  color: $bluePrimary;
}

.backgroundBirthday {
  height: 10em;
}

.dashBoardCard {
  border-top: 4px solid #fafafa !important;
  margin-bottom: 1em;
}

.noDashboardContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $background !important;
  padding: 2em 0em;
}

.noDashboardImage {
  margin: 0em 0em 1em 0em;
  margin: auto;
  background-size: contain;
  width: 50vw;
  height: 20vh;
}

.noDashboardTitle {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin-top: 1em;

  color: $bluePrimary;
}

.noDashboardSubtitle {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  color: $grayFont;
  margin-bottom: 1em;
}

.dashBoardTitle {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: $bluePrimary;
  margin-bottom: 0.3em;
}

.dashBoardContent {
  font-family: Roboto, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: $textPrimary;
}

.dashBoardVideo {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;
}

.dashBoardDocumentWithVideo {
  margin-top: 2em;
}

.adviseToZoomContainer {
  display: flex;
  justify-content: center;
}

.adviseToZoom {
  color: $button-secondary;
}

.imageCotainerDashboard {
  flex-direction: row;
  justify-content: center;
  display: flex;
}

.imageContentDashboard--mobile {
  overflow-y: auto;
  display: block;

  .imageContentDashboard {
    width: 100%;
  }
}

.imageContentDashboard {
  width: 90%;
  align-self: center;
}

.dashBoardContainerDocument {
  height: 65vh;
  margin: auto;
}

.pinch-zoom-container {
  overflow: hidden;
  position: relative;
}

.navigateContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-evenly;
  margin-top: 1em;
}

.navigateArrowsContainerRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
}

.navigateArrowsContainerRight[disabled] {
  color: red;
}

.textNavigateArrows[disabled] {
  color: $grayFont !important;
  margin-top: 5px;
}

.textNavigateArrows {
  margin-top: 5px;
}

.navigateArrowsContainerLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
}

.pagesDashboardCount {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
}

.buttonNavigateArrowsContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
}

.pendingMessage {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1em;
  margin-bottom: 1em;
}

.pendingText {
  margin-left: 0.5em;
}

.message_temp_beta {
  height: 54px;
  width: 180px;
  border-radius: 7px;
  background: #e4527f;
  text-align: center;
  padding: 5px;
  position: absolute;
  bottom: 20px;
  left: 20px;
  display: flex;

  a {
    text-decoration: none;
    color: white;
    width: 100%;
    height: 54px;
  }

  i {
    font-size: 28px;
    color: white;
  }
}

.empty-board-wrapper {
  height: 300px;
}

@media screen and (min-width: 1024px) {
  .empty-board-wrapper {
    height: 296px;
  }
}
</style>
